export { default } from './TasksListAsOwnerContent';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/_myTasksCommon/TasksListAsOwnerContent/index.js